import App from '../App';
import paymentTransactionApis from './paymentConfigs';
import { v4 as uuidv4 } from 'uuid';
/**
 *
v1/recommendation-rules/{channel}/{service}
v1/recommendation-rules/{channel}/{service}/baskets
v1/recommended-products/{channel}/{service}
 */
const networkConfig = {
    googleBaseURL: 'https://maps.googleapis.com',
    // ADYEN PAYMENT
    adyenPayment: {
        getPaymentMethods: {
            name: 'Adyen payment methods',
            url: 'v1/payment-service/paymentmethods',
            httpMethod: 'POST',
            hasQueryProps: false,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        submitPayment: {
            name: 'Submit Adyen Payment Details',
            url: 'v1/payment-service/payment',
            httpMethod: 'POST',
            hasQueryProps: false,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        submitAdditionalPayment: {
            name: 'Submit Additional Adyen Payment Details',
            url: 'v1/payment-service/paymentdetails',
            httpMethod: 'POST',
            hasQueryProps: false,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        removeStoredPayment: {
            name: 'Remove adyen stored payments',
            url: 'v1/payment-service/{storedPaymentId}/disablesavedcard',
            httpMethod: 'POST',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
    },
    // HOME PAGE
    couponsDeals: {
        nonLocalized: {
            name: 'Coupons Deals App - Non Localized',
            url: 'v1/content/{tenantId}/home/app/all',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        localizedPickup: {
            name: 'Coupons Deals App - Pickup Localized',
            url: 'v1/content/{tenantId}/home/app/pickup',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        localizedDelivery: {
            name: 'Coupons Deals App - Delivery Localized',
            url: 'v1/content/{tenantId}/home/app/delivery',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        localizedDineIn: {
            name: 'Coupons Deals App - Localized DineIn',
            url: 'v1/content/{tenantId}/home/app/dine-in',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
    },
    couponsDealsWeb: {
        nonLocalized: {
            name: 'Coupons Deals Web - Non Localized',
            url: 'v1/content/{tenantId}/home/web/all',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        localizedPickup: {
            name: 'Coupons Deals Web - Pickup Localized',
            url: 'v1/content/{tenantId}/home/web/pickup',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        localizedDelivery: {
            name: 'Coupons Deals Web - Delivery Localized',
            url: 'v1/content/{tenantId}/home/web/delivery',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        localizedDineIn: {
            name: 'Coupons Deals Web - DineIn Localized',
            url: 'v1/content/{tenantId}/home/web/dine-in',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
    },
    hiddencoupon: {
        name: 'Get Hidden Coupon',
        url: 'v1/baskets/coupon-detail/{couponcode}/{catalog}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    cartCoupons: {
        applicableCoupons: {
            name: 'Get Applicable Coupons',
            url: 'v1/baskets/{basketId}/applicable-coupons',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        applyCoupon: {
            name: 'Apply Coupon',
            url: 'v1/baskets/{basketId}/coupons',
            httpMethod: 'POST',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        removeCoupon: {
            name: 'Remove Coupon',
            url: 'v1/baskets/{basketId}/coupons/{couponCode}',
            httpMethod: 'DELETE',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        removeAllCoupon: {
            name: 'Remove All Applied Coupons',
            url: 'v1/baskets/{basketId}/line-items',
            httpMethod: 'DELETE',
            hasQueryProps: true,
            isXCorelationEnabled: true,
            isAuthenticated: true,
        },
        nonLocalisedCoupon: {
            name: 'Get Non Localised Coupons',
            url: 'v1/promotions',
            httpMethod: 'GET',
            hasQueryProps: false,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        loggedInnonLocalisedCoupon: {
            name: 'Get Logged In Non Localised Coupons',
            url: 'v1/promotions/{userId}',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
    },
    fetchMenu: {
        name: 'Fetch Menu',
        url: 'api/menu',
        httpMethod: 'GET',
    },
    appConfigs: {
        name: 'Fetch App Configs',
        url: '/api/v1/configs/{tenantCode}/{lastUpdated}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        skipLanguage: true,
    },
    sitemapData: {
        name: 'Fetch Sitemap Data',
        url: '/api/v1/seo/sitemap-data',
        httpMethod: 'GET',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    brazeSubscriptions: {
        name: 'Fetch Braze Subscriptions',
        url: '/api/v1/braze/subscriptions',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: true,
        skipLanguage: true,
    },
    brazeSubscriptionsV2: {
        name: 'Fetch Braze Subscriptions including Grouped Subscriptions',
        url: '/api/v2/braze/subscriptions/{customerId}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
        skipLanguage: true,
    },
    fetchCommPreferences: {
        name: 'Fetch Braze Communication Preferences',
        url: '/api/v1/preferences/{customerId}?src={src}&smsSubscriptionGroupId={smsSubscriptionGroupId}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
        skipLanguage: true,
    },
    updateCommPreferences: {
        name: 'Update Braze Communication Preferences',
        url: '/api/v1/preferences/{customerId}?src={src}&smsSubscriptionGroupId={smsSubscriptionGroupId}',
        httpMethod: 'POST',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
        skipLanguage: true,
    },
    offersAndDeals: {
        nonLocalized: {
            name: 'Offers and deals',
            url: 'dev/v1/content/{tenantId}/home/web/all ',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        localizedPickup: {
            name: 'Offers and deals - Pickup',
            url: 'dev/v1/content/{tenantId}/home/web/pickup',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        localizedDelivery: {
            name: 'Offers and deals- Delivery',
            url: 'dev/v1/content/{tenantId}/home/web/delivery',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        localizedDineIn: {
            name: 'Offers and deals - DineIn',
            url: 'dev/v1/content/{tenantId}/home/web/dine-in',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
    },
    // STORE
    storeStatus: {
        readyDateTimeUpdate: {
            name: 'Ready DateTime Update',
            url: 'v1/baskets/{basketId}/order-ready-datetime-updated',
            httpMethod: 'PUT',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        storeDetails: {
            name: 'Store Details',
            url: 'v1/stores/{storeId}/details',
            httpMethod: 'GET',
            hasQueryProps: true,
            isXCorelationEnabled: true,
        },
        restaurantDetails: {
            name: 'Restaurant Details',
            url: 'v1/stores/details/{storeName}/{postCode}',
            httpMethod: 'GET',
            hasQueryProps: true,
            isXCorelationEnabled: true,
        },
        contactUsRestaurantDetails: {
            name: 'Conact Us Restaurant Details',
            url: 'v1/stores',
            httpMethod: 'GET',
            hasQueryProps: true,
            isXCorelationEnabled: true,
        },
        bulkStore: {
            name: 'Get Bulk Store Current Status API Specification',
            url: 'v1/stores/status',
            httpMethod: 'POST',
            showLoader: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        store: {
            name: 'Get Store Current Status API Specification ',
            url: 'dev/v1/stores/{storeid}/{channel}/{service}/status',
            httpMethod: 'GET',
            hasQueryProps: true,
            isXCorelationEnabled: true,
        },
        storeStatusForTime: {
            name: 'Get Store Status on Future Date Time ',
            url: 'v1/stores/{storeid}/{channel}/{service}/status/{futureDateTimeInEpochFormat}',
            httpMethod: 'GET',
            hasQueryProps: true,
            isXCorelationEnabled: true,
        },
        nearbyStoresSearch: {
            name: 'Nearby Store Search API',
            url: 'v1/nearby-stores/{tenantId}/{geohash}',
            httpMethod: 'GET',
            hasQueryProps: true,
            isXCorelationEnabled: true,
            skipLanguage: true,
        },
        googleDistance: {
            name: 'Google Distance Matrix',
            url: '',
            httpMethod: 'GET',
            hasQueryProps: true,
            hasNamedProps: true,
            isXCorelationEnabled: true,
            skipLanguage: true,
        },
        orderCapacity: {
            name: 'Store Order Capacity',
            url: '/api/v1/capacity/timeslots/{storeId}/{dateTimeEpoch}',
            httpMethod: 'GET',
            hasQueryProps: true,
            isXCorelationEnabled: true,
        },
    },
    storeAvailableTimeSlots: {
        name: 'Get Available Time Slots API Specification',
        url: 'v1/stores/{storeid}/{channel}/{service}/slots/{date}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    storeAvailableAllTimeSlots: {
        name: 'Get Available all Time Slots for Current and future dates',
        url: 'v1/stores/{storeid}/{channel}/{service}/slots',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    reOrderAndRecommendations: {
        name: 'Reorder and Recommendations',
        // url: '{env}/v1/customers/{customerId}',
        url: 'v1/customers/{customerId}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    // CUSTOMER
    customerInformation: {
        name: 'Customer Info, Past order, Recommendations, Saved addresses, Cards, Fav orders, fav items and  fav Stores',
        url: 'v1/customers/{customerId}/signed-in',
        httpMethod: 'POST',
        hasQueryProps: true,
        hasNamedProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    // CART
    clearCart: {
        name: 'Clear cart',
        url: 'v1/baskets/{basketId}/line-items/cleared',
        httpMethod: 'DELETE',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    //Create baskets
    createBaskets: {
        name: 'Create baskets',
        url: 'v1/baskets',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    //UpdateCustomerID for Basket
    updateCustomerIdForBasket: {
        name: 'Upade Customer ID for baskets',
        url: 'v1/baskets/{basketId}/customer-updated/{customerId}',
        httpMethod: 'PUT',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    //Delete baskets
    deleteBaskets: {
        name: 'Delete baskets',
        url: 'v1/baskets/{basketId}',
        httpMethod: 'DELETE',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    //recommendation rules cart landing
    recommendationsRules: {
        name: 'Recommendation Rules',
        url: 'v1/recommendation-rules/{channel}/{service}/baskets',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: false,
        isXCorelationEnabled: true,
    },
    //Validate basket
    validateBasket: {
        name: 'Validate basket',
        url: 'v1/baskets/validated',
        httpMethod: 'POST',
        isAuthenticated: true,
        hasQueryProps: false,
        isXCorelationEnabled: true,
    },
    addItem: {
        name: 'add item to cart',
        url: 'v1/baskets/{basketId}/line-items',
        httpMethod: 'POST',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    fetchCartDetails: {
        name: 'Fetch Cart Details',
        url: 'v1/baskets/{basketId}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    updateQuantity: {
        name: 'Update quantity',
        url: 'v1/baskets/{basketId}/line-items/{basketLineItemId}/quantity-updated',
        httpMethod: 'PUT',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    remoteItem: {
        name: 'remove item',
        url: 'v1/baskets/{basketId}/line-items/{basketLineItemId}',
        httpMethod: 'DELETE',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    removeMultipleItems: {
        name: 'Remove multiple items',
        url: 'v1/baskets/{basketId}/line-items',
        httpMethod: 'DELETE',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    updateItem: {
        name: 'Update item',
        url: 'v1/baskets/{basketId}/line-items/{basketLineItemId}',
        httpMethod: 'PUT',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    // ORDER
    submitOrder: {
        name: 'Submit order',
        url: '{env}/v1/orders/{orderId}/submit-requested',
        httpMethod: 'POST',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    createOrder: {
        name: 'Create order',
        url: 'v1/orders',
        httpMethod: 'POST',
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    getOrder: {
        name: 'Get order',
        url: 'v1/orders/{orderId}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    getPastOrder: {
        name: 'Get Past Order',
        url: 'v1/orders/orderlookup',
        httpMethod: 'POST',
        hasQueryProps: false,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    updateCustomerIDforOrder: {
        name: 'Update Customer Id for Order',
        url: 'v1/orders/{orderId}/customerid-updated',
        httpMethod: 'PUT',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    validateOrder: {
        name: 'Validate order',
        url: 'v1/orders/order-validated',
        httpMethod: 'POST',
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    // MENU
    menu: {
        name: 'Menu',
        url: 'v1/catalogs/{tenantId}/{catalogName}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    exclusions: {
        name: 'Exclusions',
        url: 'v1/stores/{storeId}/{channel}/{service}/item-exclusions',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    futureExclusions: {
        name: 'Future Exclusions',
        url: 'v1/stores/future-item-exclusions',
        httpMethod: 'POST',
        isAuthenticated: true,
        hasQueryProps: true,
        isXCorelationEnabled: true,
    },
    specialEventItemAvailability: {
        name: 'Special Event Item Availability',
        url: 'v1/stores/{storeId}/special-event/item-availability/{date}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    recommendations: {
        name: 'Recommendations',
        url: 'v1/recommendation-rules/{channel}/{service}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: false,
        isXCorelationEnabled: true,
    },
    recommendedProducts: {
        name: 'Recommendations',
        url: 'v1/recommended-products/{channel}/{service}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: false,
        isXCorelationEnabled: true,
    },
    itemDetails: {
        name: '',
        url: 'v1/catalogs/{tenantId}/{catalogName}/items/{itemId}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    // PROFILE
    register: {
        name: 'Register Customer',
        url: '{env}/v1/customer/basic',
        httpMethod: 'POST',
        isAuthenticated: true,
    },
    updateAccount: {
        name: 'Update Customer',
        url: 'v1/customers/{customerId}/basic',
        httpMethod: 'POST',
        isAuthenticated: true,
        hasQueryProps: true,
        isXCorelationEnabled: true,
    },
    deleteAccount: {
        name: 'Delete Account',
        url: 'v1/customers/{customerId}/remove',
        httpMethod: 'DELETE',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    updateExternalCustomerId: {
        name: 'Account',
        url: 'v1/customers/{customerId}/{externalCustomerId}/update-external-customerid',
        httpMethod: 'PUT',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    accountDetails: {
        basic: {
            name: 'Basic Account Details',
            url: '{env}/v1/customer/{customerId}/basic',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
        details: {
            name: ' Account Details',
            url: '{env}/v1/customer/{customerId}/details',
            httpMethod: 'GET',
            hasQueryProps: true,
            isAuthenticated: true,
            isXCorelationEnabled: true,
        },
    },
    favouriteOrders: {
        name: 'Favourite orders',
        url: '{env}/v1/customer/{customerId}/favourite-orders',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    addOrderToFav: {
        name: 'Add order to favourites',
        url: '{env}/v1/customer/basic',
        httpMethod: 'POST',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    addStoreToFav: {
        name: 'Add Store to favourites',
        url: 'v1/customers/{customerId}/favourite-stores',
        httpMethod: 'POST',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    removeStoreToFav: {
        name: 'Remove Store to favourites',
        url: 'v1/customers/{customerId}/favourite-stores/{storeId}',
        httpMethod: 'DELETE',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    addItemToFav: {
        name: 'Add Item to favourites',
        url: 'v1/customers/{customerId}/favourite-items',
        httpMethod: 'POST',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    removeFavItem: {
        name: 'Remove favourite item',
        url: 'v1/customers/{customerId}/favourite-items/{itemId}',
        httpMethod: 'DELETE',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    myCards: {
        name: 'My Cards',
        url: '{env}/v1​/customer​/{customerId}​/saved-cards​/{cardId}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    deleteSavedCard: {
        name: 'Remove saved card',
        url: 'v1/customers/{customerId}/saved-cards/{cardId}',
        httpMethod: 'DELETE',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    saveCard: {
        name: 'Save Cards',
        url: '{env}/v1/customer/{customerId}/saved-cards',
        httpMethod: 'POST',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    myAddresses: {
    // looks same like Account Details
    },
    addCustomerAddress: {
        name: 'Add address',
        url: 'v1/customers/{customerId}/addresses',
        httpMethod: 'POST',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    editAddress: {
        name: 'Add order to favourites',
        url: 'v1/customer/{customerId}/saved-addresses',
        httpMethod: 'PUT',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    removeAddress: {
        name: 'Remove saved address',
        url: 'v1/customers/{customerId}/addresses/{addressId}',
        httpMethod: 'DELETE',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    postOrderAccepted: {
        name: 'Post Order Accepted',
        url: 'v1/orders/{orderId}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    postAddHopePayment: {
        name: 'Post Add Hope Pyament Accepted',
        url: 'v1/orders/{miscPaymentReferenceId}/get-misc-payment',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    postGiftCardPayment: {
        name: 'Post  Gift card purchase',
        url: 'v1/baskets/paymentdiscountlines/{wiCodePurchaseId}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    cancelPostOrder: {
        name: 'Cancel Order',
        url: 'v1/orders/{orderId}/cancel-requested',
        httpMethod: 'PUT',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    checkInRequest: {
        name: 'Check In Request',
        url: 'v1/orders/{orderId}/checkin-requested',
        httpMethod: 'PUT',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    getOrderHistory: {
        name: 'get Order History',
        url: 'v1/customers/{customerId}/historical-orders',
        httpMethod: 'POST',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    getActiveOrderHistory: {
        name: 'get Active Order History',
        url: 'v1/customers/{customerId}/active-historical-orders',
        httpMethod: 'POST',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    addFavOrder: {
        name: 'add Favourite order',
        url: 'v1/customers/{customerId}/favourite-orders',
        httpMethod: 'POST',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    deleteFavOrder: {
        name: 'Remove Favourite order',
        url: 'v1/customers/{customerId}/favourite-orders/{itemId}',
        httpMethod: 'DELETE',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    updateCommunicationPref: {
    // looks same as like update account.
    },
    marketingPreference: {
        name: 'Update communication Preference',
        url: 'v1/customers/{customerId}/marketing-preference',
        httpMethod: 'PUT',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    // PAYMENTS
    bankIds: {},
    flashData: {},
    updatepaymentResponseFromBillDesk: {
        name: 'Update for Payment response from Billdesk',
        url: '{env}/v1/payment-service/bill-desk/response-updated',
        httpMethod: 'POST',
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    checkPaymentStatus: {
        name: 'Check payment Status',
        url: '{env}/v1/payment-service/{transactionId}/status',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    allowedBanksForNetBanking: {
        name: 'Allowed banks for Netbanking',
        url: 'v1/payment-service/net-banking/configurations',
        httpMethod: 'GET',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    paymentForPhonePe: {
        name: 'Request Payment for PhonePe',
        url: 'v1/payment-service/phonepe-pg/requested',
        httpMethod: 'POST',
        hasQueryProps: false,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    paymentForPaytm: {
        name: 'Request Payment for Paytm',
        url: 'v1/payment-service/paytm/requested',
        httpMethod: 'POST',
        hasQueryProps: false,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    paymentForGooglePay: {
        name: 'Request Payment for GooglePay',
        url: 'v1/payment-service/google-pay/payment-requested',
        httpMethod: 'POST',
        hasQueryProps: false,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    phonePeStatus: {
        name: 'Check the status of PhonePe transaction',
        url: 'v1/payment-service/phonepe-pg/{transactionId}/status',
        httpMethod: 'GET',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    paytmToken: {
        name: 'Request Payment for Paytm',
        url: 'v1/payment-service/paytm/requested',
        httpMethod: 'POST',
        hasQueryProps: false,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    paymentUsingGiftCard: {
        name: 'Gift Card Make Payment',
        url: 'v1/payment-service/gift-card/payment-requested',
        httpMethod: 'POST',
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    allowedWalletsForOtherWallets: {
        name: 'Allowed wallets for other wallets(Apart from PhonePe and Paytm)',
        url: 'v1/payment-service/additional-wallet/configurations',
        httpMethod: 'GET',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    googleSpotInitiatePayment: {
        name: 'Initiate payment request for Google Pay Spot for the tender with orderId',
        url: 'v1/payment-service/google-pay-spot/payment-requested',
        httpMethod: 'POST',
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    googleSpotValidateResponse: {
        name: 'Validate payment response from Google Pay Spot',
        url: 'v1/payment-service/google-pay-spot/response-validated',
        httpMethod: 'POST',
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    googleSpotCheckTransactionStatus: {
        name: 'Validate transaction status for Google Pay Spot',
        url: 'v1/payment-service/google-pay-spot/{transactionId}/status',
        httpMethod: 'GET',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    paymentForAddHope: {
        name: 'Initiate transaction for add hope',
        url: 'v1/miscpayment',
        httpMethod: 'POST',
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    paymentForGifCard: {
        name: 'Initiate transaction for gift card',
        url: 'v1/baskets/paymentdiscountlines/purchase',
        httpMethod: 'POST',
        isXCorelationEnabled: true,
        isAuthenticated: true,
        allowSiteOrigin: true,
    },
    placesAutocomplete: {
        name: 'Places Autocomplete',
        url: '',
        httpMethod: 'GET',
        hasQueryProps: true,
        hasNamedProps: true,
        isXCorelationEnabled: true,
    },
    placesGeolocation: {
        name: 'Places Geolocation',
        url: '',
        httpMethod: 'GET',
        hasQueryProps: true,
        hasNamedProps: true,
        isXCorelationEnabled: true,
    },
    reverseGeocode: {
        name: 'Reverse Geocode',
        url: '',
        httpMethod: 'GET',
        hasQueryProps: true,
        hasNamedProps: true,
        isXCorelationEnabled: true,
    },
    // Auth API call
    authToken: {
        name: 'Auth Token',
        url: '',
        httpMethod: 'POST',
        hasQueryProps: false,
        skipLanguage: true,
    },
    refreshToken: {
        name: 'Refresh Token',
        url: '',
        httpMethod: 'POST',
        hasQueryProps: false,
        skipLanguage: true,
    },
    guestToken: {
        name: 'Guest Token',
        url: '',
        httpMethod: 'POST',
        hasQueryProps: false,
        skipLanguage: true,
    },
    // Help/Feedback
    submitFeedback: {
        name: 'Submit Feedback',
        url: 'v1/enquiries',
        httpMethod: 'POST',
        hasQueryProps: false,
        isXCorelationEnabled: true,
    },
    // PAYTM MINIAPP PAYMENT
    paymentForPaytmMiniApp: {
        name: 'Request Payment for Paytm Micro App',
        url: 'v1/payment-service/paytm-miniapp/requested',
        httpMethod: 'POST',
        hasQueryProps: false,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    paytmMiniAppStatus: {
        name: 'Check the status of Paytm Micro app transaction',
        url: 'v1/payment-service/paytm-miniapp/{transactionId}/status',
        httpMethod: 'GET',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    // PHONEPE SWITCH PAYMENT
    paymentForPhonepeSwitchApp: {
        name: 'Request Payment for Phonepe Switch App',
        url: 'v1/payment-service/phonepe-app/requested',
        httpMethod: 'POST',
        hasQueryProps: false,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    phonepeSwitchAppStatus: {
        name: 'Check the status of Phonepe Switch App transaction',
        url: 'v1/payment-service/phonepe-app/{transactionId}/status',
        httpMethod: 'GET',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    //GIFTCARD PURCHASE
    giftCardPurchase: {
        name: 'New Gift Card Purchase Payment Request',
        url: 'v1/giftcard-service/purchase',
        httpMethod: 'POST',
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    //GIFTCARD CHECKBALANCE
    createCheckBalance: {
        name: 'Gift-card Check balance API',
        url: 'v1/giftcard-service/card-balance',
        httpMethod: 'POST',
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    //GET GIFTCARD DETAILS
    getGiftCardDetails: {
        name: 'Get Gift-card details API',
        url: 'v1/baskets/paymentdiscountlines/senddetails',
        httpMethod: 'POST',
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    //GIFTCARD PURCHASE STATUS
    giftCardPurchaseStatus: {
        name: 'Check the status of gift card transaction',
        url: 'v1/giftcard-service/purchases/{OrderId}/status',
        httpMethod: 'GET',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    // Config Update
    tenantConfigUpdate: {
        name: 'Tenant Config Update',
        url: 'v1/configuration',
        httpMethod: 'GET',
        hasQueryProps: false,
        isXCorelationEnabled: true,
        skipLanguage: true,
    },
    paytmStatus: {
        name: 'Check the status of Paytm transaction',
        url: 'v1/payment-service/paytm/{transactionId}/status',
        httpMethod: 'GET',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    logout: {
        name: 'Logout from KFC',
        url: '',
        httpMethod: 'POST',
        hasQueryProps: false,
        hasNamedProps: false,
        isAuthenticated: true,
    },
    generateClientTokenForBraintree: {
        name: 'Generate client token for braintree',
        url: 'v1/payment-service/generatetoken',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    transactionSale: {
        name: 'transactionSale for braintree',
        url: 'v1/payment-service/transactionsale',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    transactionSubmit: {
        name: 'transactionSubmit for braintree',
        url: 'v1/payment-service/transactionsubmitforsettlement/{transactionId}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    transactionVoid: {
        name: 'transactionVoid for braintree',
        url: 'v1/payment-service/transactionvoid/{transactionId}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    updateStoreAndDisposition: {
        name: 'update store and disposition',
        url: 'v1/baskets/{basketId}/store-disposition-updated',
        httpMethod: 'PUT',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    cashTransactionId: {
        name: 'cash transaction id',
        url: 'v1/payment-service/cash-payment/requested',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    globalPaymentsInitiatePayment: {
        name: 'Global Payments Initiate Payment',
        url: 'v1/payment-service/initiate-payment',
        httpMethod: 'POST',
        hasQueryProps: false,
        isXCorelationEnabled: true,
        isAuthenticated: true,
        skipLanguage: true,
    },
    globalPaymentsGenerateToken: {
        name: 'globalPayments generate token',
        url: 'v1/payment-service/{accessTokenUsage}/token',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
        skipLanguage: true,
    },
    gloablPaymentAddress: {
        name: 'Global Payment Address',
        url: '',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: false,
        skipLanguage: true,
    },
    gloablPaymentCheckVersionUrl: {
        name: 'Global Check Version',
        url: '/api/v1/payment-service/verify-enrollment-3ds2',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: false,
        skipLanguage: true,
    },
    gloablPayment3DSIntitiateAuthUrl: {
        name: 'Global Payment Intitiate Auth',
        url: '/api/v1/payment-service/three-ds2-authentication',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: false,
        skipLanguage: true,
    },
    gloablPaymentSaveCard: {
        name: 'Global Save Card',
        url: 'v1/payment-service/payment-methods',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: false,
        skipLanguage: true,
    },
    gloablPaymentIsStore3dsEnabled: {
        name: 'Global Payments Is Store 3ds Enabled',
        url: 'v1/stores/{storeId}/details',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: true,
        skipLanguage: true,
    },
    gloablPaymentVerifyCard: {
        name: 'Global Payments Verify card',
        url: 'v1/payment-service/card-verify',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: true,
        skipLanguage: true,
    },
    getUserOfflineCoupons: {
        name: 'Get User Offline Coupons',
        url: '/coupons',
        httpMethod: 'GET',
        hasQueryProps: false,
        isAuthenticated: true,
    },
    useOfflineCoupon: {
        name: 'Create Offline Coupon Usage',
        url: '/coupons/usage',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
    },
    dgftCreditCardGenerateToken: {
        name: 'Dgft credit card generate token',
        url: '/4gtoken',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    dgftApplePayGenerateToken: {
        name: 'Dgft apple pay generate token',
        url: 'v1/payment-service/dgft/applepay-merchant-session',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: true,
    },
    dgftAuthorizePayment: {
        name: 'Request for DGFT Authorize Payment',
        url: 'v1/payment-service/dgft/{paymentType}/authorize',
        httpMethod: 'POST',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    paymentRequested: {
        name: 'Request for Japan Payment Id',
        url: 'v1/payment-service/requested',
        httpMethod: 'POST',
        hasQueryProps: false,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    giftCardBalance: {
        name: 'Request for Japan gift card Balance',
        url: 'v1/giftcard-service/balance',
        httpMethod: 'POST',
        hasQueryProps: false,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    getDgftSavedCardDetails: {
        name: 'Request for Japan Dgft get Saved Card Details',
        url: 'v1/payment-service/dgft/credit-card/{customerId}/get-cards',
        httpMethod: 'GET',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    deleteDgftSavedCardDetails: {
        name: 'Request for Japan Dgft delete Saved Card Details',
        url: '/v1/payment-service/dgft/credit-card/{customerId}/{cardId}/delete-card',
        httpMethod: 'DELETE',
        hasQueryProps: true,
        isXCorelationEnabled: true,
        isAuthenticated: true,
    },
    ...paymentTransactionApis,
    createUserMiles: {
        name: 'create-user-miles',
        url: '/user',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: false,
    },
    getUserInfoFromMiles: {
        name: 'get-user-info-from-miles',
        url: '/user',
        httpMethod: 'GET',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: false,
    },
    getUserMiles: {
        name: 'get-mile-user',
        url: '/user/miles/{uuid}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: false,
    },
    getUserMonthlyRanking: {
        name: 'get-user-monthly-ranking',
        url: '/user/miles/ranking/{uuid}',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        hasNamedProps: false,
        isXCorelationEnabled: false,
    },
    getUserMonthlyPastRanking: {
        name: 'get-user-monthly-past-ranking',
        url: '/user/miles/ranking/',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        hasNamedProps: true,
        isXCorelationEnabled: false,
    },
    getRankingView: {
        name: 'monthly-ranking',
        url: '/miles/ranking/monthly?',
        httpMethod: 'GET',
        hasQueryProps: true,
        hasNamedProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: false,
    },
    getOverallRanking: {
        name: 'overall-ranking',
        url: '/miles/ranking/total?',
        httpMethod: 'GET',
        hasQueryProps: true,
        hasNamedProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: false,
    },
    getUserMilesHistory: {
        name: 'user-miles-history',
        url: '/user/miles/history/',
        httpMethod: 'GET',
        hasQueryProps: true,
        isAuthenticated: true,
        hasNamedProps: true,
        isXCorelationEnabled: false,
    },
    balanceInquiryAPI: {
        name: 'kfc-card',
        url: '/kfccard',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: false,
    },
    unlinkCard: {
        name: 'unlink-card',
        url: '/user/unlink/{cardType}',
        httpMethod: 'POST',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: false,
    },
    linkCard: {
        name: 'link-card',
        url: '/user/link/{cardToLink}',
        httpMethod: 'POST',
        hasQueryProps: true,
        isAuthenticated: true,
        isXCorelationEnabled: false,
    },
    pontaMemberID: {
        name: 'ponta-member-id',
        url: '/user/ponta/memberid',
        httpMethod: 'POST',
        hasQueryProps: false,
        isAuthenticated: true,
        isXCorelationEnabled: false,
    },
};
networkConfig.baseURL = () => {
    return App.envVars?.oloApiBaseUrl;
};
networkConfig.imageEndPointURL = () => App.envVars?.oloImageBaseUrl;
networkConfig.placeAutoCompleteURL = '/maps/api/place/autocomplete/json?';
networkConfig.placeGeolocationURL = '/maps/api/geocode/json?';
networkConfig.reverseGeocodeURL = '/maps/api/geocode/json?';
networkConfig.distanceMatrixURL = '/maps/api/distancematrix/json?';
networkConfig.validateToken = {
    name: 'Validate JWT token with YUM',
    url: '',
    httpMethod: 'POST',
    hasQueryProps: false,
};
networkConfig.getBaseUrl = function (name) {
    let url = networkConfig.baseURL();
    switch (name) {
        case 'Fetch App Configs':
        case 'Fetch Sitemap Data':
        case 'Fetch Braze Subscriptions':
        case 'Fetch Braze Subscriptions including Grouped Subscriptions':
        case 'Fetch Braze Communication Preferences':
        case 'Update Braze Communication Preferences':
        case 'Delivery Location Localization':
        case 'Store Order Capacity':
            url = App.envVars?.appApiBaseUrl;
            break;
        case 'Places Autocomplete':
            url = `${App.envVars?.googleBaseUrl}${networkConfig.placeAutoCompleteURL}`;
            break;
        case 'Places Geolocation':
            url = `${App.envVars?.googleBaseUrl}${networkConfig.placeGeolocationURL}`;
            break;
        case 'Google Distance Matrix':
            url = `${App.envVars?.googleBaseUrl}${networkConfig.distanceMatrixURL}`;
            break;
        case 'Reverse Geocode':
            url = `${App.envVars?.googleBaseUrl}${networkConfig.reverseGeocodeURL}`;
            break;
        case 'Validate JWT token with YUM':
            url = App.envVars?.authBaseUrl;
            break;
        case 'Auth Token':
            url = App.envVars?.authBaseUrl;
            break;
        case 'Refresh Token':
            url = App.envVars?.refreshBaseUrl;
            break;
        case 'Guest Token':
            url = App.envVars?.guestBaseUrl;
            break;
        case 'Logout from KFC':
            url = App.envVars?.logoutBaseUrl;
            break;
        case 'Global Payment Address':
            url = App.envVars?.globalPaymentsVerificationUrl;
            break;
        case 'Dgft credit card generate token':
            url = App.envVars?.dgftCreditCardTokenGenerationUrl;
            break;
        case 'get-user-info-from-miles':
        case 'get-mile-user':
        case 'get-user-monthly-ranking':
        case 'get-user-monthly-past-ranking':
        case 'monthly-ranking':
        case 'user-miles-history':
        case 'kfc-card':
        case 'unlink-card':
        case 'link-card':
        case 'overall-ranking':
        case 'ponta-member-id':
        case 'create-user-miles':
        case 'Get User Offline Coupons':
        case 'Create Offline Coupon Usage':
            url = `${App.envVars?.appApiBaseUrl}/api/v1/jp-loyalty`;
            break;
        default:
            break;
    }
    return url;
};
networkConfig.getXCorelationHeader = () => ({
    'x-correlation-request-id': uuidv4(),
    'x-correlation-session-id': App.envVars?.xCorrelationSessionId,
    'app-source': App.envVars?.channel,
});
export default networkConfig;
